import Emitter from 'tiny-emitter'

const eventBus = new Emitter()

export default eventBus

export function createEventBus() {
  return new Emitter()
}
